import { render, staticRenderFns } from "./DrayageStops.vue?vue&type=template&id=d39bf388&scoped=true"
import script from "./DrayageStops.vue?vue&type=script&lang=js"
export * from "./DrayageStops.vue?vue&type=script&lang=js"
import style0 from "./DrayageStops.vue?vue&type=style&index=0&id=d39bf388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39bf388",
  null
  
)

export default component.exports